<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['openNotificationPanel']);

const { t } = useI18n();

// Get mine chats (conversations assigned to current user)
const mineChats = useMapGetter('getMineChats');

// Calculate total unread conversation count
const unreadConversationCount = computed(() => {
  const chats = mineChats.value({ assigneeType: 'me', status: 'open' });
  return chats.reduce((total, chat) => total + (chat.unread_count || 0), 0);
});

const unreadCount = computed(() => {
  if (!unreadConversationCount.value) {
    return '';
  }

  return unreadConversationCount.value < 100
    ? `${unreadConversationCount.value}`
    : '99+';
});

const hasUnreadConversations = computed(() => {
  return unreadConversationCount.value > 0;
});

function openNotificationPanel() {
  emit('openNotificationPanel');
}
</script>

<template>
  <button
    class="relative flex items-center justify-center w-6 h-6 rounded-lg hover:bg-n-alpha-1 flex-shrink-0"
    :title="t('SETTINGS.NOTIFICATIONS')"
    @click="openNotificationPanel"
  >
    <span class="i-lucide-bell size-4 text-n-slate-11" />
    <span
      v-if="hasUnreadConversations"
      class="min-h-4 min-w-4 p-0.5 px-1 bg-n-teal-9 rounded-lg absolute -top-1 -right-1.5 grid place-items-center text-[11px] leading-none text-white"
    >
      {{ unreadCount }}
    </span>
  </button>
</template>
